import { Transaction } from '../interfaces/ImportHistory';
import axios from 'axios';

export const BATCH_PROCESSES_URL = '/api/v1/batch/processes';

interface ProcessResponse {
	status: number;
	data: string;
}

export const ProcessApi = {
	async createProcess(fileName: string, fileId: string, profileId: string): Promise<ProcessResponse> {
		return await axios
			.post(`${BATCH_PROCESSES_URL}`, {
				fileName,
				guid: fileId,
				profileId,
			})
			.then(response => response.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},

	async deleteProcess(processId: string): Promise<void> {
		await axios.delete(`${BATCH_PROCESSES_URL}/${processId}`).catch(err => {
			console.error(err);
			throw err;
		});
	},
	async getProcess(processId: string): Promise<Transaction> {
		return axios
			.get(`${BATCH_PROCESSES_URL}/${processId}`)
			.then(response => response.data.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
};
